__turbopack_context__.v({
  "backgroundDog": "home-lab-module__nrtPeG__backgroundDog",
  "chapterButtons": "home-lab-module__nrtPeG__chapterButtons",
  "chapterIcon": "home-lab-module__nrtPeG__chapterIcon",
  "chapterNav": "home-lab-module__nrtPeG__chapterNav",
  "chapterTick": "home-lab-module__nrtPeG__chapterTick",
  "chapterTitle": "home-lab-module__nrtPeG__chapterTitle",
  "desktopBreak": "home-lab-module__nrtPeG__desktopBreak",
  "directionIntro": "home-lab-module__nrtPeG__directionIntro",
  "explore": "home-lab-module__nrtPeG__explore",
  "exploreArrow": "home-lab-module__nrtPeG__exploreArrow",
  "floatingFooter": "home-lab-module__nrtPeG__floatingFooter",
  "footerBrand": "home-lab-module__nrtPeG__footerBrand",
  "footerClose": "home-lab-module__nrtPeG__footerClose",
  "footerLabLink": "home-lab-module__nrtPeG__footerLabLink",
  "footerTrigger": "home-lab-module__nrtPeG__footerTrigger",
  "heroBackdrop": "home-lab-module__nrtPeG__heroBackdrop",
  "heroCopy": "home-lab-module__nrtPeG__heroCopy",
  "heroDirectionGrid": "home-lab-module__nrtPeG__heroDirectionGrid",
  "heroProjectCount": "home-lab-module__nrtPeG__heroProjectCount",
  "heroProjects": "home-lab-module__nrtPeG__heroProjects",
  "institute": "home-lab-module__nrtPeG__institute",
  "leadership": "home-lab-module__nrtPeG__leadership",
  "navArrow": "home-lab-module__nrtPeG__navArrow",
  "page": "home-lab-module__nrtPeG__page",
  "projectRibbon": "home-lab-module__nrtPeG__projectRibbon",
  "projectRibbonGroup": "home-lab-module__nrtPeG__projectRibbonGroup",
  "projectScope": "home-lab-module__nrtPeG__projectScope",
  "rail": "home-lab-module__nrtPeG__rail",
  "roomEquipment": "home-lab-module__nrtPeG__roomEquipment",
  "roomPlate": "home-lab-module__nrtPeG__roomPlate",
  "sceneAside": "home-lab-module__nrtPeG__sceneAside",
  "sceneFrame": "home-lab-module__nrtPeG__sceneFrame",
  "skipLink": "home-lab-module__nrtPeG__skipLink",
  "srOnly": "home-lab-module__nrtPeG__srOnly",
  "staffNotice": "home-lab-module__nrtPeG__staffNotice",
  "staffOverlay": "home-lab-module__nrtPeG__staffOverlay",
  "stage": "home-lab-module__nrtPeG__stage",
  "stageContent": "home-lab-module__nrtPeG__stageContent",
  "stageNumber": "home-lab-module__nrtPeG__stageNumber",
  "topLine": "home-lab-module__nrtPeG__topLine",
  "university": "home-lab-module__nrtPeG__university",
});
